<nav id="sidebarMenu" class="d-md-block bg-light sidebar collapse">
    <div class="position-sticky pt-3 sidebar-sticky">
        <ul class="nav flex-column">
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/dashboard']" (click)="hide()" routerLinkActive="active">
                    <i class="fa-solid fa-house fa-fw"></i>
                    Dashboard
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/task']" (click)="hide()" routerLinkActive="active">
                    <i class="fa-solid fa-list-check fa-fw"></i>
                    Aufgaben
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/reminder']" (click)="hide()" routerLinkActive="active">
                    <i class="fa-solid fa-bell fa-fw"></i>
                    Erinnerungen
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/archive']" (click)="hide()" routerLinkActive="active">
                    <i class="fa-solid fa-box-archive fa-fw"></i>
                    Archiv
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/trash']" (click)="hide()" routerLinkActive="active">
                    <i class="fa-solid fa-trash-can fa-fw"></i>
                    Papierkorb <ng-container *ngIf="countDeleted > 0">({{countDeleted}})</ng-container>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/settings']" (click)="hide()" routerLinkActive="active">
                    <i class="fa-solid fa-cogs fa-fw"></i>
                    Einstellungen
                </a>
            </li>
        </ul>

        <ng-container>
            <h6 class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted text-uppercase">
                <span>Stammdaten</span>
            </h6>

            <ul class="nav flex-column mb-auto">
                <li class="nav-item">
                    <a class="nav-link" [routerLink]="['/user']" (click)="hide()" routerLinkActive="active">
                        <i class="fa-solid fa-users fa-fw"></i>
                        Benutzer
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [routerLink]="['/contact']" (click)="hide()" routerLinkActive="active">
                        <i class="fa-solid fa-address-card fa-fw"></i>
                        Kontakte
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [routerLink]="['/customer']" (click)="hide()" routerLinkActive="active">
                        <i class="fa-solid fa-user-tie fa-fw"></i>
                        Kunden
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [routerLink]="['/department']" (click)="hide()" routerLinkActive="active">
                        <i class="fa-solid fa-building fa-fw"></i>
                        Abteilungen
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [routerLink]="['/tasktype']" (click)="hide()" routerLinkActive="active">
                        <i class="fa-solid fa-cubes fa-fw"></i>
                        Aufgabentypen
                    </a>
                </li>
            </ul>
        </ng-container>

        <div style="margin-left: 15px; margin-top: 25px">v{{currentApplicationVersion}}</div>
        <div class="d-grid">
            <button type="button" class="btn btn-secondary btn-sm mx-3 mt-1" (click)="logout($event)">Abmelden</button>
        </div>
    </div>
</nav>
